export default __webpack_public_path__ + "static/media/HistoricLinkedTask.bcaa837c.svg";